export default () => {
  const elms = Array.from(document.querySelectorAll("fieldset.collapsible"));

  elms.forEach(elm => {
    const legend = elm.querySelector("legend");
    const content = elm.querySelector(".collapsible-content");

    legend.onclick = event => {
      event.preventDefault();
      elm.classList.toggle("collapsed");
      content.classList.toggle("dn");
    };
  });
};
